import { PublicationClient, PubIssueDTO, DashboardNavClient, IDashboardNavClient, PublishClient, IPublishClient, LiveStatus, ISysClient, SysClient, ApiAuditModel } from "@/Generated/ParticaAPI";
import { PublicationModel } from "@/Generated/ParticaAPI";

export interface IPublicationService {
	getTitle(websiteId: number): Promise<PublicationModel>;
	getIssues(titleId: number): Promise<PubIssueDTO[]>;
	unPublishIssues(titleId: number): Promise<any>;
	publishIssues(titleId: number): Promise<any>;
	getLogs(titleId: number): Promise<ApiAuditModel[]>;
	republishIssues(titleId: number): Promise<any>;
}

export class PublicationService implements IPublicationService {
	private svc: PublicationClient = new PublicationClient();
	private navsvs: IDashboardNavClient = new DashboardNavClient();
	private publishsvc: IPublishClient = new PublishClient();
	private apisvc: ISysClient = new SysClient();

	public async republishIssues(titleId: number): Promise<any> {
		return await this.publishsvc.republishAllIssues(titleId);
	}

	public async getTitle(titleId: number): Promise<PublicationModel> {
		return await this.svc.getPublication(titleId);
	}

	public async getIssues(titleId: number): Promise<PubIssueDTO[]> {
		return await this.navsvs.getIssuesForPublication(titleId);
	}

	public async publishIssues(titleId: number): Promise<any> {
		return await this.publishsvc.publishPublicationIssues(titleId, LiveStatus.Live);
	}
	public async unPublishIssues(titleId: number): Promise<any> {
		return await this.publishsvc.publishPublicationIssues(titleId, LiveStatus.Notlive);
	}
	public async getLogs(titleId: number): Promise<ApiAuditModel[]> {
		return await this.apisvc.getPublicationAudit(titleId);
	}

}
